export const TYPE_CONST: Record<string, string> = {
    CALCULATION: 'Расчет',
    PERCENT: '',
};

export const CHAPTER_CONST: Record<string, string> = {
    CHAPTER9: 'Глава 9',
};

export interface ICheckedObjs {
    [key: number | string]: {
        [key: number | string]: any;
    };
}

export interface IOtherValues {
    [key: string]: {
        [key: string]: any;
    };
}
export interface IOtherNoteValues {
    [key: number | string]: {
        [key: number | string]: string | undefined | null;
    };
}

export interface IFormValues {
    checkedIds: {
        [key: number | string]: {
            [key: number | string | 'parent']: boolean | undefined | 'intermediate';
        };
    };
    otherPriceValues: {
        [key: number | string]: {
            [key: number | string]:
                | {
                      isIncluded: boolean | undefined;
                  }
                | {
                      includedCost: number | undefined;
                  };
        };
    };
    otherPriceNotes: {
        [key: number | string]: {
            [key: number | string]: string | undefined | null;
        };
    };
}
